import PropTypes from "prop-types";
import I18n from "@/i18n-js/instance";
import { ChatIcon } from "@circle-react/components/Chat/ChatIcon";
import { memberPaths } from "@circle-react/helpers/urlHelpers";
import {
  DropdownMenu_DEPRECATED,
  useDropdown,
} from "@circle-react-shared/DropdownMenu";
import { Icon } from "@circle-react-shared/Icon";

export const MobileActions = ({
  communityMemberId,
  showChatButton,
  showEditButton,
  removeFromSpace,
  removeFromSpaceGroup,
}) => {
  const { open, handleClose, toggleDropdown } = useDropdown();

  return (
    <div className="community-member__actions--mobile">
      <button
        type="submit"
        className="community-member__chat-button--mobile"
        onClick={toggleDropdown}
      >
        <Icon type="menu-dots" className="text-dark" useWithFillCurrentColor />
      </button>
      <DropdownMenu_DEPRECATED
        className="dropdown-menu dropdown-menu--right animate-right"
        open={open}
        handleClose={handleClose}
      >
        {showChatButton && (
          <ChatIcon
            showIcon={false}
            buttonClass="btn"
            communityMemberId={communityMemberId}
          />
        )}
        {showEditButton && (
          <a
            className="btn"
            href={memberPaths.edit({
              memberId: communityMemberId,
            })}
          >
            {I18n.t("edit")}
          </a>
        )}
        {removeFromSpace}
        {removeFromSpaceGroup}
      </DropdownMenu_DEPRECATED>
    </div>
  );
};

MobileActions.propTypes = {
  communityMemberId: PropTypes.number,
  showChatButton: PropTypes.bool,
  showEditButton: PropTypes.bool,
  removeFromSpace: PropTypes.node,
  removeFromSpaceGroup: PropTypes.node,
};
